export default {
  getCommerces: state => state.commerces
}
